/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".my-label[_ngcontent-%COMP%]{letter-spacing:1px;font-size:.7rem;color:#e56c11!important}.qrcode[_ngcontent-%COMP%]{min-height:120px}"];
export { styles as styles };
